import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

import { useIsAnyStepSubmitted } from './hooks';

export const PROMT_MESSAGE = "You have unsaved changes, are you sure you want to leave?";

const RenewalSetupPrompt: React.FC<{ isPromptDisabled?: boolean }> = ({ isPromptDisabled }) => {
  const isAnyStepSubmitted = useIsAnyStepSubmitted();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isAnyStepSubmitted && !isPromptDisabled) {
        e.preventDefault();
        e.returnValue = PROMT_MESSAGE;
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isAnyStepSubmitted, isPromptDisabled]);

  return (
    <Prompt
      when={isAnyStepSubmitted && !isPromptDisabled}
      message={PROMT_MESSAGE}
    />
  );
};

export default RenewalSetupPrompt;
